import { privacyPoints } from '../searchConfig';

export function PrivacyBand() {
  return (
    <section className="privacy-band" aria-label="Search privacy promises">
      <div className="privacy-band__inner">
        <div className="privacy-band__visual" aria-hidden="true">
          <div className="shield-mark">
            <svg viewBox="0 0 24 24">
              <path d="M12 3 5 6v5c0 4.4 2.8 8.4 7 10 4.2-1.6 7-5.6 7-10V6l-7-3Z" />
              <path d="m8.8 12 2.1 2.1 4.3-4.5" />
            </svg>
          </div>
          <span>privacy first</span>
          <strong>No profile trail</strong>
        </div>
        <div className="privacy-band__content">
          <p className="privacy-band__eyebrow">Curated search protections</p>
          <h2>Your searches should feel useful, not watched.</h2>
          <ul>
            {privacyPoints.map((point) => (
              <li key={point}>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="m5 12.5 4 4L19 7" />
                </svg>
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
